{
  "name": "@ns/create-public-ledger-account",
  "version": "1.1.0",
  "description": "A public ledger account creation job",
  "inputs": {},
  "outcomes": {
    "complete": {}
  },
  "jobMetadata": [
    "JOB_STAGE",
    "HAS_BEEN_SAVE"
  ],
  "publicLedger": [
    {
      "id": "account-creation",
      "kind": "ACCOUNT_CREATION"
    }
  ]
}
